/* global organisationEventsUrl organisationEventsDeleteUrl organisationEventDashboardUrl */
/* global organisationEventsCloneUrl organisationEventsCreateUrl organisationRolesUrl */
/* global organisation canViewRoles canViewEventDetails organisationEventRateCardUrl organisationEventStatusUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import OrganisationEvents from './OrganisationEvents';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

import useQuery from 'Hooks/useQuery';

export default function OrganisationEventsIndex(props) {
    const rolesRequest = useQuery({
        enabled: props.canViewRoles,
        queryFn: () => axios.get(props.organisationRolesUrl),
    });

    return (
        <OrganisationEvents
            roles={rolesRequest.data || []}
            organisation={props.organisation}
            organisationEventsUrl={props.organisationEventsUrl}
            organisationEventsDeleteUrl={props.organisationEventsDeleteUrl}
            organisationEventDashboardUrl={props.organisationEventDashboardUrl}
            organisationEventRateCardUrl={props.organisationEventRateCardUrl}
            organisationEventStatusUrl={props.organisationEventStatusUrl}
            organisationEventsCloneUrl={organisationEventsCloneUrl}
            organisationEventsCreateUrl={organisationEventsCreateUrl}
            canViewEventDetails={props.canViewEventDetails}
        />
    );
}

if (document.getElementById('OrganisationEvents')) {
    var rootEl = document.getElementById('OrganisationEvents');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <OrganisationEventsIndex
                    organisationEventsUrl={organisationEventsUrl}
                    organisationEventsDeleteUrl={organisationEventsDeleteUrl}
                    organisationEventDashboardUrl={organisationEventDashboardUrl}
                    organisationEventRateCardUrl={organisationEventRateCardUrl}
                    organisationEventStatusUrl={organisationEventStatusUrl}
                    organisationEventsCloneUrl={organisationEventsCloneUrl}
                    organisationEventsCreateUrl={organisationEventsCreateUrl}
                    organisationRolesUrl={organisationRolesUrl}
                    organisation={organisation}
                    canViewRoles={canViewRoles}
                    canViewEventDetails={canViewEventDetails}
                />
            </ConfirmationModalProvider>
        </App>,
        rootEl,
    );
}
